import { Tag } from "antd";

export interface StatusConfig {
  label: string;
  color?: string;
  //icon?: React.ReactNode;
}

interface StatusTagProps {
  value?: string;
  options: Record<string, StatusConfig>;
  fallback?: string;
}

export const StatusTag = ({
  value,
  options,
  fallback = "-",
}: StatusTagProps) => {
  if (!value) {
    return <Tag>{fallback}</Tag>;
  }

  const config = options[value];

  if (!config) {
    return <Tag>{value}</Tag>;
  }

  return (
    <Tag color={config.color}>
      {/* config.icon */}
      {config.label}
    </Tag>
  );
};